import React from 'react';
import { TextInput } from '@mantine/core';
import { formatPhoneNumber, validatePhoneNumber } from '../../utils/phoneUtils';

function PhoneInput({ 
  value, 
  onChange, 
  error, 
  disabled = false,
  required = false,
  label = "Phone",
  placeholder = "(xxx) xxx-xxxx",
  ...props 
}) {
  const handleChange = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    onChange(formattedValue);
  };

  const handleBlur = (e) => {
    if (props.onBlur) {
      props.onBlur(e);
    }
    if (!validatePhoneNumber(e.target.value) && e.target.value.length > 0) {
      if (props.onError) {
        props.onError('Please enter a valid 10-digit phone number');
      }
    }
  };

  return (
    <TextInput
      label={label}
      required={required}
      placeholder={placeholder}
      value={value || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      disabled={disabled}
      {...props}
    />
  );
}

export default PhoneInput; 